import { AveMode } from "../types";
export default class ConfigService {
    constructor(initConfig) {
        var _a, _b, _c, _d;
        this.aveMode = AveMode.CLOUD;
        this.config = {
            instanceMatchingUrl: (_a = initConfig === null || initConfig === void 0 ? void 0 : initConfig.instanceMatchingUrl) !== null && _a !== void 0 ? _a : "https://matchmaker.eu-west-1-web-streaming.avp.tech",
            inactivityTimeout: (_b = initConfig === null || initConfig === void 0 ? void 0 : initConfig.inactivityTimeout) !== null && _b !== void 0 ? _b : 300,
            reconnectGracePeriod: (_c = initConfig === null || initConfig === void 0 ? void 0 : initConfig.reconnectGracePeriod) !== null && _c !== void 0 ? _c : 0,
            environment: (_d = initConfig === null || initConfig === void 0 ? void 0 : initConfig.environment) !== null && _d !== void 0 ? _d : "production",
        };
    }
    isLocalMode() {
        return this.aveMode === AveMode.LOCAL;
    }
    setLocalAveContext(aveUrl) {
        this.aveMode = AveMode.LOCAL;
        this.config.instanceMatchingUrl = aveUrl;
    }
    getStreamingConfig() {
        return {
            inactivityTimeoutTimeInSeconds: this.config.inactivityTimeout,
            reconnectGracePeriodInSeconds: this.config.reconnectGracePeriod,
        };
    }
}
//# sourceMappingURL=config-service.js.map